module.exports = __webpack_public_path__ + "images/smartorg_logo_transparent.png";


//////////////////
// WEBPACK FOOTER
// ./app/views/azure-login-fail/images/smartorg_logo_transparent.png
// module id = 426
// module chunks = 0